import { Card, CardContent } from "@/components/ui/card";
import { Star, Quote } from "lucide-react";

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: "Marie L.",
      event: "Mariage",
      rating: 5,
      text: "Gemima a créé le gâteau de mariage de mes rêves ! Magnifique et délicieux, tous nos invités ont été émerveillés. Un grand merci pour cette création unique qui a rendu notre jour J encore plus magique.",
      date: "Septembre 2024"
    },
    {
      name: "Thomas B.",
      event: "Anniversaire",
      rating: 5,
      text: "Layer cake au chocolat absolument parfait pour les 30 ans de ma femme. La décoration était exactement ce que nous avions imaginé et le goût... un pur délice ! Je recommande vivement.",
      date: "Août 2024"
    },
    {
      name: "Sophie M.",
      event: "Baby Shower",
      rating: 5,
      text: "Les cupcakes étaient magnifiques et tellement bons ! Gemima a su parfaitement interpréter notre thème pastel. Tout le monde a adoré, merci pour cette belle surprise gourmande.",
      date: "Juillet 2024"
    },
    {
      name: "Laurent D.",
      event: "Anniversaire d'entreprise",
      rating: 5,
      text: "Commande pour notre événement d'entreprise : service impeccable, livraison à l'heure et gâteau spectaculaire ! Nos collaborateurs ont été ravis. Nous referons appel à Sweets by Gem.",
      date: "Juin 2024"
    },
    {
      name: "Camille R.",
      event: "Baptême",
      rating: 5,
      text: "Number cake en forme de 1 pour le baptême de notre fils. C'était exactement ce que nous voulions : élégant, pas trop sucré et avec de belles fleurs fraîches. Parfait !",
      date: "Mai 2024"
    },
    {
      name: "Julien P.",
      event: "Saint-Valentin",
      rating: 5,
      text: "Bento cake surprise pour ma copine : elle a fondu en larmes (de joie) ! Le petit gâteau était adorable et délicieux. Gemima a vraiment le don pour créer de l'émotion avec ses gâteaux.",
      date: "Février 2024"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-pink-50/30 to-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            💖 Témoignages clients
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Découvrez ce que nos clients pensent de nos créations. 
            Chaque avis nous motive à continuer de créer des moments sucrés inoubliables.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="border-pink-100 hover:shadow-elegant transition-smooth relative overflow-hidden">
              <div className="absolute top-4 right-4 text-primary opacity-20">
                <Quote className="w-8 h-8" />
              </div>
              
              <CardContent className="pt-6">
                {/* Rating */}
                <div className="flex items-center mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>

                {/* Testimonial Text */}
                <blockquote className="text-gray-700 leading-relaxed mb-6 italic">
                  "{testimonial.text}"
                </blockquote>

                {/* Client Info */}
                <div className="border-t border-pink-100 pt-4">
                  <div className="flex justify-between items-start">
                    <div>
                      <div className="font-semibold text-gray-900">
                        {testimonial.name}
                      </div>
                      <div className="text-sm text-primary font-medium">
                        {testimonial.event}
                      </div>
                    </div>
                    <div className="text-xs text-gray-500">
                      {testimonial.date}
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Stats Section */}
        <div className="mt-16">
          <div className="bg-white rounded-2xl p-8 shadow-elegant border border-pink-100">
            <div className="grid md:grid-cols-4 gap-8 text-center">
              <div>
                <div className="text-3xl font-bold text-primary mb-2">150+</div>
                <div className="text-gray-600">Gâteaux créés</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-primary mb-2">98%</div>
                <div className="text-gray-600">Clients satisfaits</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-primary mb-2">24h</div>
                <div className="text-gray-600">Temps de réponse moyen</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-primary mb-2">2 ans</div>
                <div className="text-gray-600">D'expérience à Villeurbanne</div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-pink-50 to-yellow-50 rounded-xl p-8 border border-pink-100 max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              ✨ Rejoignez nos clients satisfaits
            </h3>
            <p className="text-gray-600 mb-6">
              Faites confiance à Sweets by Gem pour créer le gâteau parfait 
              pour votre événement. Chaque création est unique et faite avec amour.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => {
                  const element = document.querySelector("#contact");
                  if (element) {
                    element.scrollIntoView({ behavior: "smooth" });
                  }
                }}
                className="inline-flex items-center justify-center px-8 py-4 bg-primary text-white rounded-lg hover:bg-primary/90 transition-smooth font-medium text-lg shadow-elegant"
              >
                🎂 Commander maintenant
              </button>
              <button
                onClick={() => window.open("https://wa.me/33753797698", "_blank")}
                className="inline-flex items-center justify-center px-8 py-4 border-2 border-primary text-primary rounded-lg hover:bg-primary hover:text-white transition-smooth font-medium text-lg"
              >
                💬 Discuter avec Gem
              </button>
            </div>
          </div>
        </div>

        {/* Review Invitation */}
        <div className="mt-12 text-center">
          <p className="text-gray-500 text-sm">
            Vous avez commandé chez nous ? 
            <button 
              onClick={() => window.open("https://www.instagram.com/sweetsby_gem", "_blank")}
              className="text-primary hover:underline ml-1"
            >
              Partagez votre expérience sur Instagram
            </button>
          </p>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;